<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<template>
  <div>
    <v-text-field
      class="not-print-applicant-details-item"
      type="email"
      v-model="input"
      :counter="counter"
      :rules="[
        validateIsEmail,
        validateRequired,
      ]"
      :required="required"
      :maxlength="maxLength"
      :disabled="disabled"
    ></v-text-field>
    <span class="print-applicant-details-item">
      {{ input }}
    </span>
  </div>
</template>

<script>
import Vue from "vue";
import InputShortAnswer from "./InputShortAnswer.vue";
import { requireTextIsEmail } from "../utils/validationUtils";

export default Vue.extend({
  name: "InputEmail",
  mixins: [InputShortAnswer],
  props: {mlLibJson:Object,},
  data() {
    return {
      formValid: true,
    };
  },
  methods: {
    validateIsEmail(input) {
      let is_valid = !input || requireTextIsEmail(input);

      if (is_valid) {
        return true;
      } else {
        let message = "正しいメールを入力してください。";
        return message;
      }
    },
  },
});
</script>
